import { JSConn } from "@/utilities/js-conn";
import { format } from "date-fns";

export default {
  name: "FWWorkOrderTaskShow",
  props: {
    workOrderTaskId: String,
  },
  data() {
    return {};
  },
  methods: {
    skipTask: function() {
      // 2019-09-24
      // similar functionality to the finish work order task form
      const jsConnWorkOrderTask = new JSConn();

      const td = format(new Date(), "yyyy-MM-dd");
      if (this.workOrderTask.start_date === null) {
        this.workOrderTask.start_date = td;
      }

      if (this.workOrderTask.completed_date === null) {
        this.workOrderTask.completed_date = td;
      }

      jsConnWorkOrderTask.formParams = {
        id: this.workOrderTaskId,
        status: "completed",
        start_date: this.workOrderTask.start_date,
        completed_date: this.workOrderTask.completed_date,
      };

      // nothing is being done with the line items.
      // the quantity should be fine

      const dataPromises = [
        this.$store.dispatch("completeWorkOrderTask", jsConnWorkOrderTask),
      ];

      Promise.all(dataPromises).then(() => {
        if (this.nextTaskId !== this.workOrderTaskId) {
          this.$router.push({
            name: "fwWorkOrderTaskShow",
            params: {
              workOrderId: this.workOrder.id,
              workOrderTaskId: this.nextTaskId,
            },
          });
        }
        this.$emit("tasksChanged");
        return Promise.resolve();
      });
    },
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    workOrderTask: function() {
      return this.$store.getters.workOrderTaskById(this.workOrderTaskId);
    },
    lineItems: function() {
      return this.workOrderTask.work_order_task_line_items;
    },
    previousTaskId: function() {
      const pId = this.$store.getters.workOrderPreviousTaskId(
        this.workOrderTaskId,
      );
      if (pId === "") {
        return this.workOrderTaskId;
      } else {
        return pId;
      }
    },
    previousButtonDisabled: function() {
      if (this.previousTaskId === this.workOrderTaskId) {
        return true;
      } else {
        return false;
      }
    },
    nextTaskId: function() {
      const nId = this.$store.getters.workOrderNextTaskId(this.workOrderTaskId);
      if (nId === "") {
        return this.workOrderTaskId;
      } else {
        return nId;
      }
    },
    nextButtonDisabled: function() {
      if (this.nextTaskId === this.workOrderTaskId) {
        return true;
      } else {
        return false;
      }
    },
    taskFormButtonText: function() {
      if (this.workOrderTask.status === "completed") {
        return "Edit Task";
      } else {
        return "Finish Task";
      }
    },
  },
};
